// src/views/Restaurant/ClientManagement/ReservationManagement/components/
// ReservationConfiguration/components/ReservationDays/components/SalonReservations.tsx

import React, { useState } from 'react';
import { Button } from 'react-bootstrap';
import { PatchUpdate } from '../../../../../../../../../../crud/management_api/reservations_configuration';
import { Configuration } from '../../../../../../types';
import { ChevronUp,ChevronDown } from 'react-bootstrap-icons';
import './SalonReservations.scss';
import { getSalonesByLocalId } from 'crud/management_api/salones';

interface Props {
  day: number;     
  data: Configuration;
  onPatch: (updates: PatchUpdate[]) => Promise<void>;
}

const SalonReservations: React.FC<Props> = ({ day, data, onPatch }) => {
  const [open, setOpen] = useState(false);
  const [mesaTags, setMesaTags] = useState<Record<number, string | null>>({});

  // Debug: call getSalonesByLocalId on mount to inspect endpoint response
  React.useEffect(() => {
    try {
      const user = JSON.parse(localStorage.getItem('user') || '{}');
      const localId = user?.local_id ?? 0;
      if (localId) {
        getSalonesByLocalId(localId)
          .then((res) => {
            // Normalize access to the array of salones
            let payload: any = res;
            if (res && res.data !== undefined) payload = res.data;
            // payload should be an array of salones
            if (Array.isArray(payload)) {
              const map: Record<number, string | null> = {};
              payload.forEach((salon: any) => {
                if (salon && Array.isArray(salon.mesas)) {
                  salon.mesas.forEach((mesa: any) => {
                    const id = Number(mesa.mesa_id ?? mesa.table_id ?? mesa.id ?? 0);
                    map[id] = mesa.tag ?? null;
                  });
                }
              });
              setMesaTags(map);
            } else {
              console.warn('[SalonReservations] unexpected payload shape from getSalonesByLocalId', payload);
            }
          })
          .catch((err) => {
            console.error('[SalonReservations] getSalonesByLocalId error:', err);
          });
      } else {
        console.warn('[SalonReservations] no localId found in localStorage user');
      }
    } catch (err) {
      console.error('[SalonReservations] error reading localStorage user', err);
    }
  }, []);

  const toggleSalon = async (salonId: number) => {
    const cur = data.salon_reservations[day][salonId].active;
    await onPatch([{ path: ['salon_reservations', String(day), String(salonId), 'active'], value: !cur }]);
  };

  
  const toggleTable = async (salonId: number, tableId: number) => {
    const cur = data.salon_reservations[day][salonId].tables[tableId].active;
    await onPatch([{
      path: ['salon_reservations', String(day), String(salonId), 'tables', String(tableId), 'active'],
      value: !cur,
    }]);
  };

  return (
    <div className="salon-reservations">
      <Button variant="link" className="sr-config" onClick={() => setOpen(!open)}>
        {!open ? 'Configurar mesas' : 'Ocultar mesas'}
        {open ? <ChevronUp /> : <ChevronDown />}
      </Button>
      
      {open && (
        <>
          <div className="sr-help-text">
            <span className="help-icon">💡</span>
            <span className="help-message">
              Activa los salones y mesas que deseas ofrecer para reservas en este día.
            </span>
          </div>
          <div className="sr-list">
          {Object.entries(data.salon_reservations[day]).map(([sid, salon]) => {
            const salonId = Number(sid);
            return (
              <div key={salonId} className="sr-salon">
                <Button
                  variant="link"
                  className={`sr-salon-btn ${salon.active ? 'active' : 'inactive'}`}
                  onClick={() => toggleSalon(salonId)}
                >
                  {salon.name}
                </Button>
                <div className="sr-tables">
                  {Object.entries(salon.tables).map(([tid, table]) => {
                    const tableId = Number(tid);
                    return (
                      <Button
                        key={tableId}
                        variant="link"
                        className={`sr-table-btn ${table.active ? 'active' : 'inactive'} ${salon.active ? '' : 'disabled'}`}
                        onClick={() => toggleTable(salonId, tableId)}
                        title={typeof table.number !== 'undefined' ? `Mesa ${table.number}` : undefined}
                      >
                        {mesaTags[tableId] ? mesaTags[tableId] : table.number}
                      </Button>
                    );
                  })}
                </div>
              </div>
            );
          })}
        </div>
        </>
      )}
    </div>
  );
};

export default SalonReservations;